export const renderPercentage = (percentage) => {
  if (Math.sign(percentage.value) === -1) {
    return percentage.value * -1
  }
  return percentage.value
}
